import React, { PureComponent } from 'react';

import { CSSTransition } from 'react-transition-group';

import { ToastAPI } from '@philips-emr/tws-components-api';
import { Type } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { bool, eventListener, expression, node, number, oneOf, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, enumValues, isDefined, isEnumValid, isFunction } from '@philips-emr/tws-utils';

import './toast.scss';

const acceptedTypes = [
  ComponentType.LAYOUT,
];

@AwesomeComponent({ type: ComponentType.FEEDBACK, api: ToastAPI })
class Toast extends PureComponent {
  static propTypes = {
    children: node.notEnumerable(),
    className: string.notEnumerable(),
    initialOpen: bool,
    onBeforeClose: eventListener,
    onClose: eventListener,
    showCloseButton: bool,
    timeOut: number,
    type: oneOf(enumValues(Type)),
    uuid: string,
    value: expression,
  };

  static defaultProps = {
    type: Type.NEUTRAL,
  };

  state = {
    open: false,
  };

  componentDidMount() {
    const { initialOpen } = this.props;

    if (isDefined(initialOpen)) {
      this.setState({ open: initialOpen });
    }
  }

  shouldClose = () => {
    const { onBeforeClose } = this.props;

    let close = true;

    if (isFunction(onBeforeClose)) {
      const abortFn = () => close = false;

      onBeforeClose({ abort: abortFn });
    }

    return close;
  };

  closeToast = () => {

    if (!this.shouldClose()) {
      return;
    }

    this.setState({ open: false });

    const { onClose } = this.props;

    if (isFunction(onClose)) {
      onClose();
    }
  };

  render() {
    const { children, className, showCloseButton, timeOut, type, uuid, value } = this.props;
    const { open } = this.state;

    if (open && timeOut) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      this.timeoutId = setTimeout(this.closeToast, timeOut);
    }

    const lightTheme = type !== Type.CAUTION;

    const Container = ContainerProvider.provide(this);

    const classes = classNames({
      'c-toast': true,
      [`c-toast--${type}`]: isEnumValid(Type, type),
      't-light': lightTheme,
      [className]: Boolean(className),
    });

    return (
      <CSSTransition
        in={open}
        timeout={300}
        classNames="c-toast__slide"
        unmountOnExit
      >
        <Container className={classes} acceptedTypes={acceptedTypes} uuid={uuid}>
          <div className="c-toast__message" x-contrast="bg cl">{msg(value)}</div>
          <div className="c-toast__actions u-expand">
            {children}
          </div>
          {showCloseButton ? <a onClick={this.closeToast} className="c-toast__close" /> : null}
        </Container>
      </CSSTransition>
    );
  }
}

export default Toast;
